import { useCallback, useMemo } from 'react';
import qs from 'qs';
import { useRouter } from '@tribeplatform/react-sdk';
const defaultParseOptions = {
    allowDots: true,
    ignoreQueryPrefix: true,
};
const defaultStringifyOptions = {
    allowDots: true,
    format: 'RFC1738', // encode space character as '+'
};
export const useQueryParams = ({ navigationMode = 'push', parseOptions, stringifyOptions, } = {}) => {
    const { push, replace, location: { search }, } = useRouter();
    const queryParams = useMemo(() => {
        const mergedParseOptions = { ...defaultParseOptions, ...parseOptions };
        return qs.parse(search, mergedParseOptions);
    }, [parseOptions, search]);
    const setQueryParams = useCallback((newValue) => {
        const mergedStringifyOptions = {
            ...defaultStringifyOptions,
            ...stringifyOptions,
        };
        const newQuery = { ...queryParams, ...newValue };
        switch (navigationMode) {
            case 'push':
                push(`?${qs.stringify(newQuery, mergedStringifyOptions)}`);
                return undefined;
            case 'replace':
                replace(`?${qs.stringify(newQuery, mergedStringifyOptions)}`);
                return undefined;
            default: {
                // Code should never reach the default case
                const exhaustiveCheck = navigationMode;
                return exhaustiveCheck;
            }
        }
    }, [navigationMode, push, queryParams, replace, stringifyOptions]);
    return [queryParams, setQueryParams];
};
//# sourceMappingURL=useQueryParams.js.map